import { Employee } from "src/redux/types/_employee.type";
import { formatDateDDMM } from "src/utils";


const OfferLetter = (employee: Employee) => {
  //name, employee id, date, address, role name, amount, month,

  return (
    <div className="p-6 max-w-4xl mx-auto border rounded-lg shadow-lg bg-white text-justify text-pretty">
      <h1 className="text-2xl font-bold text-center mb-4">Offer Letter</h1>
      <p>
        <strong>Name:</strong> - {employee?.full_name.toUpperCase()}, <strong>Employee ID: </strong> -{" "}
        {employee?.id}
      </p>
      <p>
        <strong>Date:</strong> - {formatDateDDMM(new Date().toDateString())}
      </p>
      <p>
        <strong>Address: </strong> -{employee?.current_address.toUpperCase()}
      </p>
      <p className="mt-4">
        Dear{" "}
        <span className="font-semibold">
          {employee?.full_name.toUpperCase()}
        </span>
        ,
      </p>
      <p>
        We are pleased to offer you the position of{" "}
        <strong>{employee?.department.toUpperCase()}</strong> at{" "}
        <strong>National Health & Wellness Mission</strong>. Based on our
        discussions and mutual understanding, we hereby confirm your appointment
        under the following terms and conditions:
      </p>

      <h2 className="text-lg font-semibold mt-4">Appointment</h2>
      <p>
        1. This appointment is effective from{" "}
        <span className="font-bold text-lg">
          {formatDateDDMM(employee.date_of_joining)}
        </span>
        . You will be working remotely since the joining date or in the Office
        of National Healthcare & Wellness Mission situated at Hengrabari,
        Guwahati, Assam.
      </p>
      <p>
        2.Your job functions and responsibilities as [Role] will be as defined
        broadly in this Appointment Letter.
      </p>

      <h2 className="text-lg font-semibold mt-4">
        Remuneration, Increment or Promotion
      </h2>
      <p>
        3. Your gross monthly salary will be{" "}
        <span className="font-bold text-lg">₹ </span> payable
        on the [date] of every month. All overtime is covered by this
        remuneration.
      </p>
      <p>
        4. Your salary and other allowances shall be as per enclosed statement
        in Annexure.
      </p>
      <p>
        5.Your future increments or promotion or any other salary increase shall
        be based on merit considering your periodic and consistent overall
        performance, business conditions and other parameters fixed from time to
        time at the discretion of the management and shall not be considered
        merely as a matter of right.
      </p>
      <h2 className="text-lg font-semibold mt-4">Probationary Period</h2>
      <p>
        6. You will be placed on probation for a period of [Month] and on the
        expiry of the period of probation, if you are not confirmed in writing,
        your services shall be deemed to be automatically terminated. However,
        unless you are confirmed in writing, you shall not be deemed to be
        permanent. For completing the probation period successfully, you have to
        comply with the instructions of work given to you on time to time.
      </p>
      <p>
        7. During probation, the notice period for termination/resignation will
        be [Days] from either side. After confirmation, the notice period
        required from either side is [Days]. In the circumstances of any
        unethical event or activity, dishonesty in behaviour or works, lying in
        words or work, irregularity in working time; Company’s Management has
        the complete right to take any necessary action for short term or long
        term without any prior notice which may sometimes lead to immediate
        termination or separation of your employment without any remuneration or
        full and final settlement.
      </p>
      <p>
        8. After successful completion of your probation, you will be confirmed
        in writing as a permanent employee of the Company. You will be entitled
        to statutory and service benefits and be governed by discipline and
        other rules existing or may come into existence from time to time, as
        and when applicable as per rules of the Company and such other benefits
        as applicable to employees in force from time to time to the
        location/place wherever you are working. The company depending upon need
        shall take suitable cover of GPA to take care of liability under Workmen
        Compensation Act after successfully completion of probationary period,
        provided you are not covered under ESI Scheme.
      </p>
      <p>
        9. During the probationary period no leave is allowed. Emergency leave
        will be allowed only by producing appropriate proof with documentation.
      </p>
      <p>
        10. You will not have any week-end holiday during probation when you
        fail to complete the task of the project assigned to you.
      </p>
      <h2 className="text-lg font-semibold mt-4">
        Working Hours And Attendance
      </h2>
      <p>
        11. Your designated work hours will be [……AM-……..PM] Monday to Saturday
        with a [….minutes ] break.{" "}
      </p>
      <p>
        12.You have to put as much as possible time to finish your daily task.
        No task should be left pending. Industry standard time requirements is 8
        hrs. per day.
      </p>
      <p>
        13.You must adhere to company attendance policies, monitored via:
        <ol>
          <li>Login System</li>
          <li>Daily Check-in Check-out</li>
          <li>Task Tracking</li>
        </ol>
      </p>
      <h2 className="text-lg font-semibold mt-4">Leave Policy</h2>
      <p>
        14. Leave request must be submitted in advance, except in emergencies
      </p>
      <p>
        15.Excessive unplanned leaves or repeated absenteeism may result in
        salary deductions.
      </p>
      <h2 className="text-lg font-semibold mt-4">
        Termination And Retirement Policy
      </h2>
      <p>
        16.You shall retire from the services of the Company on attaining 60
        years of age. Your date of birth for the purpose of Company’s record is
        entered as 13th Jan’ 2001 as per scanned copy of PAN Card submitted by
        you. During the tenure of your services, you will wholly devote yourself
        to the work assigned to you and will not undertake any other employment
        either on full or part time basis without prior permission of the
        Company in writing. Any contravention of this condition will entail
        termination of your services from the Company.
      </p>
      <p>
        17.Your services are liable to be terminated at any time :-
        <ul>
          <li>
            During probation or after confirmation, in case you are found to be
            medically unfit by the Company’s Authorized Medical practitioner, on
            examination;
          </li>
          <li>
            As and when the Company comes to know of any conviction by the Court
            of Law during the tenure of your service with us or conviction and /
            or any bad record in the past under the previous employer, or
            because of your giving false information at the time of your
            appointment or concealed any material information or given any false
            details in the application form or otherwise as regard age,
            education qualification, experience, salary etc.
          </li>
          <li>
            If you are found to be not possessing desired qualification which do
            not confirm to custom authority and / govt. regulation as may be
            required from time to time and necessary for continuation of
            business or its exigencies or on account of redundancy.
          </li>
        </ul>
      </p>
      <p>
        18.if you are found to be not possessing desired qualification which do
        not confirm to custom authority and / govt. regulation as may be
        required from time to time.
      </p>
      <p>
        19.Unresponsiveness or prolonged inactivity during work hours without
        prior notice will be considered Unjustified Absence.
      </p>
      <p>
        20.The Employment relationship shall finish at the end of the month in
        which the Employee reaches pensionable age without requiring notice of
        termination.
      </p>
      <p>
        21.The Employment relationship can be terminated by either party by
        giving 3 months’ notice
      </p>
      <p>
        22.Periods to the end of a calendar month. Notice of termination will be
        issued in writing.
      </p>
      <p>
        23.In the event of termination, the employer is free to relieve the
        Employee of his duties unless barred by overriding interests of the
        Employee.
      </p>
      <h2 className="text-lg font-semibold mt-4">Activity</h2>
      <p>
        24.During the period of service with the company, you shall not indulge
        and/ or take part in any activity of formation of council and / or
        association or become a member being part of management staff which are
        found to be detrimental in the interest of the company in any way. Such
        an action shall be deemed as infringement to service conditions of the
        company and amount to causing damage to its interest and shall call for
        disciplinary action being taken against you, as it may deem fit and
        appropriate.
      </p>
      <p>
        25.You shall carry out the job of [Role] and any works connected with or
        incidental to which is necessary for business of the Company. You shall
        do any other work assigned to you, which you are capable of doing or
        work at any other post which has been assigned to you.
      </p>
      <p>
        26.You shall faithfully and to the best of your ability perform your
        duties that may be entrusted to you from time to time by the management.
        You will be bound by rules, regulations and orders promulgated by the
        management in relation to conduct, discipline and policy matters. You
        will not seek membership of any local or public bodies without first
        obtaining specific permission of the management. In the event of your
        becoming member without following due process as mentioned, it shall
        amount to contravention of provision of employment condition and the
        management reserves the right to take appropriate action including
        dispensing with your services, as it may deem fit. You will not give out
        to any one, by word of mouth or otherwise, particulars of our business
        or administrative or organizational matters of a confidential nature
        which may be your privilege to know by virtue of your being our
        employee.
      </p>
      <p>
        27.Any misrepresentation of work location, falsification of attendance,
        or failure to meet responsibilities will result strict action.
      </p>

      <h2 className="text-lg font-semibold mt-4">
        Use of Company's Equipments
      </h2>
      <p>
        28.While you are in employment of the company, you may be given or
        handed over company’s property and/or equipment for official or business
        operational use and you shall take care of them including their upkeep.
        On cessation of employment with the Company, you shall return all
        documents, books, tools, papers relating to the affairs of the Company,
        purchased with the Company’s money, which may have come to you, and also
        any property of the Company in your possession.
      </p>
      <p>
        29.Any company provided hardware, tools, books must be used strictly for
        work purpose.
      </p>
      <p>
        30.Unauthorized modification, transfer, or resale of company assets will
        lead to legal action.
      </p>
      <p>
        31.All documents, plans, drawings, prints, trade secrets, technical
        information reports, statements, correspondence etc., written or
        unwritten and also information and instructions that pass through you or
        come to your knowledge shall be treated as confidential. You shall not
        utilize them for your own use or disclose to other persons during or
        after your employment. During the course of employment with the Company,
        you will acquire, gain generate, gather and develop knowledge of and be
        given access to business information about products activities,
        know–how, methods or refinements and business plans and business secrets
        and other information concerning the products/business of the Company,
        hereinafter called the “SECRETS”. You will be liable for prosecution for
        damages for divulgence, sharing or parting any of such information
        during course of employment and on cessation for at least 2 years
        period.
      </p>
      <h2 className="text-lg font-semibold mt-4">
        Confidentiality and Non-Disclosure
      </h2>
      <p>
        32.You agree to maintain the confidentiality of all company information
        and not disclose it to any third party during or after your employment.
      </p>

      <h2 className="text-lg font-semibold mt-4">
        Service Transfer and Deployment Clause
      </h2>
      <p>
        33.With / Without transfer, wholly or partially, from one department to
        another or to office/ branch and vice-versa or office/ branch to another
        office/ branch of an associate company, existing or to come into
        existence in future or any of the Company’s branch office or locations
        anywhere in India or abroad or any other concern where this Company has
        any interest. In such case, you will abide by responsibilities expressly
        vested or implied or communicated and shall follow rules and regulations
        of the department / office, establishment, jointly or separately,
        without any compensation or extra remuneration or provision of
        accommodation. You, thereupon, may be governed by service conditions and
        other terms of the said concern as may be applicable.
      </p>
      <p>
        34.The aforesaid Clause (i) will not give you any right to claim
        employment in any associate/sister concern, or ask for a common
        seniority with the employee of sister/associate concern.
      </p>
      <h2 className="text-lg font-semibold mt-4">
        Notification of changes in Residential Area
      </h2>
      <p>
        35.You will keep the Company informed of any change in your residential
        address that may happen during the course of employment of your service
        with the company.
      </p>

      <h2 className="text-lg font-semibold mt-4">Financial Liabilities</h2>
      <p>
        36.Any balance of advance taken by you from the Company, shall be fully
        recovered from your salary and any other legal dues including Gratuity,
        at the time of your leaving the services of the Company.
      </p>
      <p>
        37.While working as an employee if you enter into any business
        transaction with any party on behalf of the company within your
        permissible limits, it shall be your responsibility to ensure recovery
        of outstanding. If any outstanding remains at the time of leaving the
        services of the company, it shall be your responsibility to recover for
        remittance to the company before you proceed to settle your legal dues
        in full and final settlement of your account.
      </p>

      <h2 className="text-lg font-semibold mt-4">Tax Compliance</h2>
      <p>
        38.The company is obliged to deduct Income Tax at source as per
        provision of Income Tax Act/Rules. Accordingly, you are required to
        submit all required proof of permitted savings / investments and other
        details from time to time to enable the company to comply with the
        provisions of law. In the event of non-compliance by you as aforesaid if
        the company is required to pay any interest or payment under Income Tax
        Act, it shall deduct the amount as may be paid or payable from your
        salary or other payments and you shall allow the company to comply with
        these requirements without objection.
      </p>
      <h2 className="text-lg font-semibold mt-4">Legal Jurisdiction</h2>
      <p>
        39.All disputes arising out of this letter will be subject to the
        jurisdiction of the Guwahati High Court. And that the courts, tribunals
        and/or authorities at Guwahati only shall have jurisdiction to
        entertain, try and decide such disputes or differences arising out of or
        pertaining to this contract of employment, irrespective of your working
        HQ being elsewhere at those times.
      </p>

      <h2 className="text-lg font-semibold mt-4">
        Reporting Structure and Workplace Discipline
      </h2>
      <p>
        40.You have to report in daily basis to the [Reporting person ] and
        sometimes to the MD also. You have to keep & show appropriate respect to
        the senior management of the Company/NHWM and you can’t leave office
        without permission of your senior/s.
      </p>

      <p className="mt-4">
        You are requested to return the enclosed copies duly signed on all pages
        on [Date] before 2:00 PM, as a token of your acceptance of the rules,
        regulations, terms and conditions of your employment in Optim Health and
        wellness (OPC) Pvt. Ltd. or NHWM.
      </p>
      <p className="mt-4">
        Hope that this will be the beginning of a long and successful career
        with us.
      </p>
      <p className="mt-4">Yours faithfully,</p>
      <p>
        <strong>For Optim Health and Wellness (OPC) Pvt. Ltd.</strong>
      </p>
    </div>
  );
};

export default OfferLetter